export class DailyReportFieldModel {
    public Id: number;
    public Name: string;
    public CustomEditorName: string;
    public ExcludedValues: string;
    public FieldName: string;
    public FieldTypeFlag: string;
    public IsRequired: boolean;
    public Value: any;
}



// WEBPACK FOOTER //
// ./src/app/models/daily-report-field-model.ts